import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Layout from '../../components/Layout/Layout';
import classes from './Videos.css';
import BSMLogo from '../../assets/logos/benito-santos-mexico.svg';
import BSNoviasLogo from '../../assets/logos/benito-santos-novias.svg';
import SectionHeader from '../../components/SectionHeader/SectionHeader';
import SectionMenu from '../../components/SectionMenu/SectionMenu';
import * as menuActions from '../../actions/MenuActions';
import * as videosActions from '../../actions/VideosActions';
import { Helmet } from 'react-helmet';
import ResponsiveEmbed from 'react-responsive-embed';
import { Carousel } from 'react-responsive-carousel';

let isBrides;

class Press extends Component {
    constructor(props) {
        super(props);
        this.config();
    }

    state = {
        videoIndex: 0
    };

    componentDidUpdate(nextProps) {
        if (nextProps.match !== this.props.match) {
            this.config();
        }
    }

    config = () => {
        const { path } = this.props.match;

        isBrides = path === '/videos/novias' ? true : false;

        this.props.hideAllMenus().then(() => {
            this.props.showTopMenu();
        });

        this.props.getVideos(isBrides ? 'novias' : 'tailormade');
    };

    handleCarouselChange = index => {
        this.setState({ videoIndex: index });
    };

    handleMenuClick = (event, index) => {
        event.preventDefault();
        this.setState({ videoIndex: index });
    };

    render() {
        const { videos } = this.props;
        const { videoIndex } = this.state;

        return (
            <Layout>
                <Helmet>
                    <title>Benito Santos - Videos</title>
                </Helmet>
                <section className="container">
                    <header className="row justify-content-center">
                        <div className="col-sm-7 col-xl-4">
                            <SectionHeader
                                logo={isBrides ? BSNoviasLogo : BSMLogo}
                                logoAlt={
                                    'Benito Santos - ' + isBrides
                                        ? 'Novias'
                                        : 'México'
                                }
                                title="Videos"
                            >
                                <SectionMenu menuItems={videos.menu} />
                            </SectionHeader>
                        </div>
                    </header>
                    {videos.items.length > 0 ? (
                        <main
                            style={{
                                margin: '40px auto'
                            }}
                        >
                            <h3 className={classes.VideoTitle}>
                                {videos.items[videoIndex].title}
                            </h3>
                            <Carousel
                                showThumbs={false}
                                showArrows={true}
                                showStatus={false}
                                showIndicators={false}
                                infiniteLoop={true}
                                emulateTouch={true}
                                selectedItem={videoIndex}
                                onChange={this.handleCarouselChange}
                            >
                                {videos.items.map((item, index) => (
                                    <div key={index}>
                                        <ResponsiveEmbed
                                            src={item.url}
                                            allowFullScreen
                                        />
                                    </div>
                                ))}
                            </Carousel>
                            <ul className={classes.MenuList}>
                                {videos.items.map((item, index) => (
                                    <li key={index}>
                                        <a
                                            href=""
                                            onClick={event =>
                                                this.handleMenuClick(
                                                    event,
                                                    index
                                                )
                                            }
                                            className={
                                                index === videoIndex
                                                    ? classes.ActiveMenu
                                                    : null
                                            }
                                        >
                                            {item.title}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </main>
                    ) : null}
                </section>
            </Layout>
        );
    }
}

const mapStateToProps = state => {
    return {
        menu: state.menu,
        videos: state.videos
    };
};

const mapDispatchToStore = dispatch => {
    return bindActionCreators(
        {
            ...menuActions,
            ...videosActions
        },
        dispatch
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToStore
)(Press);



// WEBPACK FOOTER //
// ./src/containers/Videos/Videos.js